import React from 'react';
import PropTypes from 'prop-types';

import Loader from 'components/Loader/Loader';
import Panel from 'components/Panel/Panel';
import PanelHeader from 'components/PanelHeader/PanelHeader';

import ConnectStep from './ConnectStep';
import RejectedStep from './RejectedStep';
import SetupStep from './SetupStep';
import TestPaymentStep from './TestPaymentStep';
import WaitingRegistrationStep from './WaitingRegistrationStep';

import Close24 from 'icons/Close24';

import styles from '../../terminal.scss';

const stepToComponentMap = {
    connect: ConnectStep,
    waitingRegistration: WaitingRegistrationStep,
    waitingTestPayment: TestPaymentStep,
    succeeded: SetupStep,
    rejected: RejectedStep,
};

const getStepByRegistrationStatus = (status) => {
    switch (status) {
        case 'PENDING':
        case 'MANUAL_BOARDING':
            return 'waitingRegistration';
        case 'WAITING_FOR_TEST':
            return 'waitingTestPayment';
        case 'SUCCEEDED':
            return 'succeeded';
        case 'REJECTED':
            return 'rejected';
        default:
            return 'connect';
    }
};

function Yookassa(props) {
    const { onCancel, onTerminalSave, isLoading, terminalSettings } = props;

    const { registration_status } = terminalSettings;
    const Component = stepToComponentMap[getStepByRegistrationStatus(registration_status)];

    return (
        <Panel
            separated={true}
            contentStyles={{ minWidth: 400, maxWidth: 400, padding: '0 0.5rem' }}
            header={
                <PanelHeader title={'Платёжный терминал'} back={true} onBackClick={onCancel} backIcon={<Close24 />} />
            }
        >
            <div className={styles.settings}>
                {isLoading && (
                    <div className={styles.loader}>
                        <Loader dark={true} />
                    </div>
                )}

                {Component && !isLoading && (
                    <Component
                        onTerminalSave={onTerminalSave}
                        isLoading={isLoading}
                        terminalSettings={terminalSettings}
                    />
                )}
            </div>
        </Panel>
    );
}

Yookassa.propTypes = {
    id: PropTypes.number,
    type: PropTypes.string,
    isLoading: PropTypes.bool,
    onCancel: PropTypes.func,
    onTerminalSave: PropTypes.func,
    terminalSettings: PropTypes.shape({
        terminal_key: PropTypes.string,
        terminal_password: PropTypes.string,
        return_url: PropTypes.string,
        registration_status: PropTypes.oneOf([
            'PENDING',
            'MANUAL_BOARDING',
            'WAITING_FOR_TEST',
            'SUCCEEDED',
            'REJECTED',
        ]),
        taxation_type: PropTypes.oneOf(['osn', 'usn_income', 'usn_income_outcome', 'patent', 'envd', 'esn']),
        ffd: PropTypes.oneOf(['1.05', '1.2']),
        vat: PropTypes.oneOf(['none', 'vat0', 'vat5', 'vat10', 'vat18', 'vat110', 'vat118', 'vat120']),
    }),
};

export default Yookassa;
